import {Components} from '@exp1/front-utils'
import {roleHooks} from 'hooks/roles'
import {serviceHooks} from 'hooks/services'
import {omit} from 'lodash'
import {useNavigate} from 'react-router-dom'
import {getItemName} from 'utils/findItem'

export const List = () => {
  const navigate = useNavigate()
  const roleListQuery = roleHooks.useListQuery()
  const serviceListQuery = serviceHooks.useListQuery()

  const createEntity = () => navigate('/roles/create')

  const headers = [
    {key: 'name', value: 'Name'},
    {key: 'code', value: 'Code'},
    {key: 'serviceName', value: 'Service'},
    {key: 'edit'},
  ]

  if (!roleListQuery.data || !serviceListQuery.data) {
    return null
  }

  const rows = roleListQuery.data.map((role) => ({
    key: role.id,
    columns: {
      ...omit(role, 'permissions'),
      serviceName: getItemName(serviceListQuery.data, role.serviceId),
      edit: <Components.EditLink to={`/roles/${role.id}/edit`} />,
    },
  }))

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between">
        <Components.Header.H5>Roles</Components.Header.H5>
        <Components.Button onClick={createEntity}>Add</Components.Button>
      </div>
      <Components.Table headers={headers} rows={rows} />
    </div>
  )
}
